import i18n from '@/plugins/i18n';

export const tooltip = {
  mounted(el, binding) {
    el.handleMouseEnter = () => {
      if (!binding.value) return;
      const tip = document.createElement('div');
      tip.textContent = i18n.global.t(binding.value);
      tip.style.position = 'fixed';
      tip.style.zIndex = '1000';
      const rect = el.getBoundingClientRect();
      const position = binding.arg || 'top';
      tip.classList.add('tooltip-type-1', 'tooltip-' + position);
      switch(position) {
        case 'top':
          tip.style.bottom = `${window.innerHeight - rect.top + 8}px`;
          tip.style.left = `${rect.left + rect.width/2}px`;
          tip.style.transform = 'translateX(-50%)';
          break;
        case 'right':
          tip.style.left = `${rect.right + 8}px`;
          tip.style.top = `${rect.top + rect.height/2}px`;
          tip.style.transform = 'translateY(-50%)';
          break;
        case 'left':
          tip.style.right = `${window.innerWidth - rect.left + 8}px`;
          tip.style.top = `${rect.top + rect.height/2}px`;
          tip.style.transform = 'translateY(-50%)';
          break;
        default:
          tip.style.top = `${rect.bottom + 8}px`;
          tip.style.left = `${rect.left + rect.width/2}px`;
          tip.style.transform = 'translateX(-50%)';
      }
      document.body.appendChild(tip);
      el._tooltip = tip;
    };
    el.handleMouseLeave = () => {
      if (el._tooltip) {
        el._tooltip.remove();
        delete el._tooltip;
      }
    };
    el.addEventListener('mouseenter', el.handleMouseEnter);
    el.addEventListener('mouseleave', el.handleMouseLeave);
  },
  updated(el, binding) {
    // Update text if still visible
    if (el._tooltip && binding.value) {
      el._tooltip.textContent = i18n.global.t(binding.value);
    }
  },
  unmounted(el) {
    el.removeEventListener('mouseenter', el.handleMouseEnter);
    el.removeEventListener('mouseleave', el.handleMouseLeave);
    if (el._tooltip) el._tooltip.remove();
    delete el.handleMouseEnter;
    delete el.handleMouseLeave;
    delete el._tooltip;
  }
};